import _ from '@lodash';
import * as Actions from '../Actions/AgendamentoEdicaoActions';

const initialState = {
    data: null,
    error: null,
    info: null,
    warning: null,
    pessoasprodutosempresa: null,
    locaisempresa: null,
    horarioagendado: null,
    dialog: {}
};

const AgendamentoEdicaoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_AGENDAMENTOEDICAO:
            {
                let AHorarios = state.horarioagendado;
                let ADialog = {};
                Object.keys(state.dialog).forEach(key => {
                    if (!_.isUndefined(state.dialog[key]) && !_.isNull(state.dialog[key])) {
                        ADialog[key] = state.dialog[key];
                    }
                });

                if (!_.isUndefined(action.payload) && !_.isNull(action.payload) && !_.isUndefined(action.name) && !_.isNull(action.name)) {
                    ADialog[action.name] = action.payload;
                }
                else if (!_.isUndefined(action.name) && !_.isNull(action.name)) {
                    delete ADialog[action.name];
                    if (!_.isNull(AHorarios)) {
                        delete AHorarios[action.name];
                    }
                }
                else {
                    ADialog = {};
                    AHorarios = null;
                }
                return {
                    ...state,
                    dialog: ADialog,
                    dadosresponsavel: null,
                    horarioagendado: AHorarios
                };
            }
        case Actions.AGENDAMENTOEDICAO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.AGENDAMENTOEDICAO_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                    id: action.id
                };
            }
        case Actions.AGENDAMENTOEDICAO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.GET_LOCAISEMPRESA:
            {
                return {
                    ...state,
                    locaisempresa: action.payload
                };
            }
        case Actions.GET_PESSOASPRODUTOSEMPRESA:
            {
                return {
                    ...state,
                    pessoasprodutosempresa: action.payload
                };
            }
        case Actions.GET_HORARIOAGENDADO:
            {
                let AHorarioAgendado = (!_.isNull(state.horarioagendado) ? state.horarioagendado : {});
                if (_.isUndefined(action.Name) || _.isNull(action.Name)) {
                    AHorarioAgendado = null;
                }
                else {
                    AHorarioAgendado[action.Name] = action.payload;
                }
                return {
                    ...state,
                    horarioagendado: AHorarioAgendado
                };
            }
        case Actions.GET_DADOSRESPONSAVEL:
            {
                return {
                    ...state,
                    dadosresponsavel: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default AgendamentoEdicaoReducer;
